export default __webpack_public_path__ + "img/bg.e8d1bd29.jpg";